import {
  API_STATES
} from '@/helpers'

const state = {
  workSchedulesState : API_STATES.NOT_REQUESTED,
  workSchedulesError : null,
  workSchedules      : {},

  employeesFilter      : [],
  employeesFilterState : API_STATES.NOT_REQUESTED,
  employeesFilterError : null,

  positionsFilter      : [],
  positionsFilterState : API_STATES.NOT_REQUESTED,
  positionsFilterError : null,

  departmentFilter      : [],
  departmentFilterState : API_STATES.NOT_REQUESTED,
  departmentFilterError : null,

  storeActiveEmployees           : [],
  storeActiveEmployeesGetState   : API_STATES.NOT_REQUESTED,
  storeActiveEmployeesGetError   : null,
  storeEmployeesHavingMailId     : [],
  storeEmployeesHavingCellNumber : [],

  pagination : {
    filter : {
      dateRange : {
        startDate : null,
        endDate   : null,
      },
      employeeIds         : [],
      positionId          : null,
      departmentId        : null,
      wsViewType          : 'default',
      wsType              : ['meal','shift'],
      wsCondensedExport   : false,
      wsUnpublishedShifts : false,
      wsApprovedTimeOff   : false,
      wsShowHours         : false,
      wsShowPosition      : true,
      wsShowSchedOff      : false,
      wsShowCell          : false
    },
    sortBy     : 'User:firstname',
    descending : false
  },


  weeklyWorkSchedulesEmailSentSuccessMessage   : null,
  sendEmailWeeklyWorkSchedulesToEmployeesState : API_STATES.NOT_REQUESTED,
  sendEmailWeeklyWorkSchedulesToEmployeesError : null,

  weeklyWorkSchedulesSmsSentSuccessMessage   : null,
  sendSmsWeeklyWorkSchedulesToEmployeesState : API_STATES.NOT_REQUESTED,
  sendSmsWeeklyWorkSchedulesToEmployeesError : null
}

export default state
